import {IEventIdentifyDataDefinition} from '@/services/segment/models/IdentifyEventModel';
import {
  IEventDataSchema,
  TrackingEvent,
} from '@/services/segment/models/TrackingManagerEventModel';
import {ITrackingService} from '@/services/tracking/ITrackingService';

/**
 * Local-dev / test stand-in for the real analytics providers. Never calls
 * out to Mixpanel/Segment — just logs what would have been tracked.
 *
 * Used by `useTrackingManager` on localhost so both providers can stay free
 * of `isLocalhost` branching, and can be swapped in for unit tests via
 * `jest.mock('@/services', ...)` to assert on tracking calls without
 * touching a real provider.
 */
export const mockTrackingService = (): ITrackingService => {
  const trackNavigation = (path: string): void => {
    console.log('🧪 mockTrackingService - trackNavigation:', path);
  };

  const trackEvent = (
    eventName: TrackingEvent,
    eventData: IEventDataSchema,
  ): void => {
    console.log('🧪 mockTrackingService - trackEvent:', eventName, eventData);
  };

  const trackIdentifyEvents = (
    identity: string,
    eventData: IEventIdentifyDataDefinition,
  ): void => {
    console.log(
      '🧪 mockTrackingService - trackIdentifyEvents:',
      identity,
      eventData,
    );
  };

  const reset = (): void => {
    console.log('🧪 mockTrackingService - reset');
  };

  return {
    trackNavigation,
    trackEvent,
    trackIdentifyEvents,
    reset,
  };
};
